import { useEffect } from "react";
import { Card } from "antd";
import { t } from "i18next";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import AppConfig from "../../core/service/AppConfig";
import ConfigPanel from "./ConfigPanel";

/** Sunucu yapılandırması. Yetki: CONFIG_MANAGE (marka yetkisinden ayrı, daha üst seviye). */
export default function SystemSettingsPage()
{
    useEffect(() => {
        document.title = `${t("System")} | ${AppConfig.getRisTitle()}`;
    }, []);

    return (
        <LayoutWithSider sidebarTitle={t("System")} fullWidth>
            <Card title={t("System")} className="settings-card">
                <ConfigPanel />
            </Card>
        </LayoutWithSider>
    );
}
